import React from 'react'
import ServicesCountriesList from '../../pages/Commercial/ServicesCountries/List'
import ServicesCountriesCreate from '../../pages/Commercial/ServicesCountries/Create'
import ServicesCountriesUpdate from '../../pages/Commercial/ServicesCountries/Update'
import ServicesCountriesView from '../../pages/Commercial/ServicesCountries/View'
import PrivateRoute from '../PrivateRoute'
import { CustomSwitch } from '../../components/CustomSwitch'

export const ServicesCountriesRouter = (): JSX.Element => (
  <CustomSwitch>
    <PrivateRoute
      path="/commercial/servicesCountries"
      exact
      component={ServicesCountriesList}
    />
    <PrivateRoute
      path="/commercial/servicesCountries/create"
      exact
      component={ServicesCountriesCreate}
    />
    <PrivateRoute
      path="/commercial/servicesCountries/view/:id"
      exact
      component={ServicesCountriesView}
    />
    <PrivateRoute
      path="/commercial/servicesCountries/update/:id"
      exact
      component={ServicesCountriesUpdate}
    />
  </CustomSwitch>
)
